import * as React from 'react';
import cx from 'classnames';
import style from './Contact.css';
import {Feedback} from './Feedback';
import shape from '_images/shape1.svg';
import {InitialProjectContext} from "components/InitialProject";
import {Button} from "components/Button";

let WOW = function () {
};
if (typeof window !== 'undefined') {
    WOW = require('wowjs');
}

export class Contact extends React.Component {
    componentDidMount() {
        if (typeof window !== 'undefined') {
            let wow = new WOW({
                mobile: false,
                live: true,
                scrollContainer: null,
                offset: 80
            });
            wow.init();
        }

        const {location} = this.props;

        if (location && location.state && location.state.scrollTo) {
            this.anchor.scrollIntoView({
                behavior: 'smooth'
            });
        }
    }

    componentWillReceiveProps(nextProps) {
        const {location} = nextProps;
        if (location && location.state && location.state.scrollTo) {
            this.anchor.scrollIntoView({
                behavior: 'smooth'
            });
        }
    }

    render() {
        return (
            <div className={style.root}>
                <header className={style.header}>
                    <img className={cx(style.shape, style.shape1, 'rotation slow')} src={shape}/>
                    <img className={cx(style.shape, style.shape2, 'rotation slower')} src={shape}/>
                    <img className={cx(style.shape, style.shape3, 'rotation slow')} src={shape}/>

                    <div className="container">
                        <h1 className={cx(style.title, 'wow', 'fadeInUp')}>Get in touch</h1>
                        <p className={cx(style.text, 'wow', 'fadeInUp')} data-wow-delay="0.25s">
                            BlockScience ® is an engineering, R&D, and analytics firm specializing in complex systems. For inquiries, email us at <a href="mailto:info@block.science" target="_blank" className={cx(style.whiteLink)}>info@block.science</a>
                        </p>
                    </div>
                </header>
                {/*<div className={style.content}>
                    <div className="container">
                        <ul className={cx(style.contactList, 'wow fadeInLeft')} data-wow-delay="0.25s">
                             <li>
                                <h3>Our mail</h3>
                                <a href="mailto:media@block.science" target="_blank">media@block.science</a>
                            </li>
                        </ul>
                        <div className={cx(style.feedback, 'wow fadeInRight')} data-wow-delay="0.25s">
                            <Feedback/>
                        </div>
                    </div>
                    <div className="container">
                        <div className={style.initialProject} ref={c => this.anchor = c}>
                            <h2>Have a&nbsp;project and need some help?</h2>
                            <p className={style.desc}>Please fill out this form to&nbsp;the best of&nbsp;your knowledge.
                                This form will help
                                BlockScience understand your vision of&nbsp;the project and your current progress.
                                Please
                                do&nbsp;not close this form until you have completed and submitted, otherwise your
                                answers will
                                not be&nbsp;saved.
                            </p>
                            <InitialProjectContext.Consumer>
                                {onClick => (
                                    <Button
                                        className={cx(style.button, 'wow', 'fadeIn')}
                                        data-wow-delay="0.3s"
                                        data-wow-offset="0"
                                        onClick={onClick}
                                    >
                                        Initial Project
                                    </Button>
                                )}
                            </InitialProjectContext.Consumer>
                        </div>
                    </div>
                </div>*/}
            </div>
        )
    }
}
